//@flow

import {FilePond, File, registerPlugin} from 'react-filepond'

import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageCrop from 'filepond-plugin-image-crop'
import FilePondPluginImageResize from 'filepond-plugin-image-resize'
import FilePondPluginImageTransform from 'filepond-plugin-image-transform'
import FilePondPluginFilePoster from 'filepond-plugin-file-poster'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImageEdit from 'filepond-plugin-image-edit'

import * as Doka from '../../../priv/static/vendor/doka-4.1.0/doka.esm.min'

const doka = Doka.create({
  cropAspectRatioOptions: [
    {label: 'Free', value: null},
    {label: 'Portrait', value: 1.25},
    {label: 'Landscape', value: 0.75},
    {label: 'Square', value: '1:1'},
  ],
})

registerPlugin(
  FilePondPluginFilePoster,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginFileValidateType,
  FilePondPluginImageTransform,
  FilePondPluginImageEdit
)

export {FilePond, File, doka}
